import React, { createContext, useState } from 'react';

const GlobalStateContext = createContext();

const GlobalStateProvider = ({ children }) => {
  const [position, setPosition] = useState(null);
  const [viewAllActivities, setViewAllActivities] = useState(false) 
  const [viewRecall, setViewRecall] = useState(false) 
  const [vehicleImages, setVehicleImages] = useState(false)

  const [installedApps, setInstalledApps] = useState([]);
  const [isAndroidAppInstalled, setIsAndroidAppInstalled] = useState(false);
  const [isIosAppInstalled, setIsIosAppInstalled] = useState(false);
  const [isSupported, setIsSupported] = useState(false);
  const [error, setError] = useState(null);

  return (
    <GlobalStateContext.Provider
      value={{
        position, setPosition,
        viewAllActivities, setViewAllActivities,
        viewRecall, setViewRecall,
        vehicleImages, setVehicleImages,
        installedApps, setInstalledApps,
        isAndroidAppInstalled, setIsAndroidAppInstalled,
        isIosAppInstalled, setIsIosAppInstalled,
        isSupported, setIsSupported,
        error, setError
      }}>
      {children}
    </GlobalStateContext.Provider>
  );
};

export { GlobalStateContext, GlobalStateProvider };
